/**
 * Formats split values for display by replacing hyphens with spaces
 * @param split - The split value to format (e.g., "up-to-2", "all-together")
 * @returns Formatted split value (e.g., "up to 2", "all together")
 */
export const formatSplitDisplay = (split: string | undefined | null): string => {
  if (!split) return '-';
  
  // Replace hyphens with spaces
  return split.replace(/-/g, ' ');
};

/**
 * Formats category values for consistent display
 * @param category - The category value to format
 * @returns Formatted category value
 */
export const formatCategoryDisplay = (category: string | undefined | null): string => {
  if (!category) return '-';
  return category;
};